__turbopack_context__.v({
  "body": "Card-module-scss-module__IUn-EW__body",
  "header": "Card-module-scss-module__IUn-EW__header",
  "line-break": "Card-module-scss-module__IUn-EW__line-break",
  "list": "Card-module-scss-module__IUn-EW__list",
  "listElement": "Card-module-scss-module__IUn-EW__listElement",
  "text-align_center": "Card-module-scss-module__IUn-EW__text-align_center",
});
